
















import Vue from "vue";
import TheNavigationDrawer from "@/components/TheNavigationDrawer.vue";

export default Vue.extend({
  name: "TheHeader",

  computed: {
    title() {
      const suffix = this.$root.$data.title
        ? " - " + this.$root.$data.title
        : this.$route.meta.toolbarTitle
        ? " - " + this.$route.meta.toolbarTitle
        : "";
      return `Pii Masker${suffix}`;
    }
  },

  components: {
    TheNavigationDrawer
  },

  data: () => ({
    drawer: null
  })
});
